export const portfolioLandlord = {
  heading: 'portfolio-landlord-page-heading',
  sectionHeading: 'portfolio-landlord-section-heading',
  sectionBody: 'portfolio-landlord-section-body'
};